import service from '@/api/service/service';
import qs from "qs";

// 获取保存文档列表
export function getDocumentList(params = {}) {
    return service({
        url: '/api/organization/class_notes_List.json',
        method: 'GET',
        params,
    })
}

// 删除文件存档
export function deleteNotes(data = {}) {
  return service({
    url: '/api/organization/class_notes_deleted.json',
    method: 'post',
    data:qs.stringify(data)
  })
}

//添加文件存档
export function createNotes(data = {}) {
  return service({
    url: '/api/organization/class_notes_upload.json',
    method: 'post',
    data:qs.stringify(data)
  })
}
// 点击上传课堂笔记按钮
export function createNotesBefore(data = {}) {
  return service({
    url: '/api/organization/class_notes_upload_before.json',
    method: 'post',
    data:qs.stringify(data)
  })
}

